import * as OPTIONS from "@/classes/parametrage/options";

export const PARAMETRAGE = [
  { idGarantie: OPTIONS.SOCLE_INTERMINISTERIEL, taux: 1.0 },
  { idGarantie: OPTIONS.OPTION_1, taux: 0.38 },
  { idGarantie: OPTIONS.OPTION_2, taux: 1.04 },
];
